<div class="top">
  <h2 mat-dialog-title>
    <mat-icon svgIcon="business" aria-hidden="false"></mat-icon>
    Vælg organisationer
    @if (maxSelectCount && maxSelectCount > 0) {
      <span>(max {{ maxSelectCount }} organisationer)</span>
    }
  </h2>
  <a (click)="loadSelectedOrganizations()" class="top__chosen btn-icon">
    <div matBadge="{{ selectedOrganizationCount }}" matBadgeOverlap="false">Valgt</div>
  </a>
  <a (click)="resetOrganizations()" class="top__reset btn-icon"> Nulstil valg </a>
  <button class="btn-close btn-icon" mat-dialog-close>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="actions">
    <mat-form-field class="actions__query" [formGroup]="filterModel">
      <mat-label>Søg organisationer</mat-label>
      <input matInput placeholder="Navn eller adresse" formControlName="query" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    @if (!maxSelectCount) {
      <div class="margin--top-s">
        <mat-slide-toggle color="primary" [disabled]="loading | async" [checked]="selectAll" (toggleChange)="onSelectAllToggle()">
          @if (selectAll) {
            Fravælg alle i listen
          }
          @if (!selectAll) {
            Vælg alle i listen
          }
        </mat-slide-toggle>
      </div>
    }
  </div>

  <div>
    <div mat-dialog-content class="organizations-selector">
      <adm-loading-spinner [loading$]="loading"></adm-loading-spinner>
      <mat-selection-list #locations [formControl]="organizationCheckboxes">
        @for (organization of organizationItems; track organization.id) {
          @defer (on viewport) {
            <mat-list-option
              class="organizations-selector__organizations-item"
              checkboxPosition="after"
              [value]="organization"
              [selected]="organization.checked"
              (click)="organizationOptionWasClicked(organization.id)"
              [disabled]="disableCheckboxes && !organization.checked">
              <div class="organizations-selector__organizations-item--name">
                {{ organization.name }}
              </div>
            </mat-list-option>
          } @placeholder {
            <div></div>
          }
        }
      </mat-selection-list>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="actions__button" type="submit" mat-flat-button color="primary" (click)="saveAndClose()">Anvend</button>
</mat-dialog-actions>
